import React from 'react'
import { Text, View } from 'styles/reactnative'

const ErrorHandling = ({ success, error }) => {
	return (
		<View style={{ alignItems: 'flex-start', marginBottom: 5 }}>
			<Text size={12} style={{ color: success ? 'green' : 'red' }}>
				{success ? success : error}
			</Text>
		</View>
	)
}

export default ErrorHandling
